var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btx-ck-editor"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"disabled":_vm.disabled,"value":_vm.editorData,"config":_vm.editorConfig},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }